import { Suspense, lazy } from 'react';
import PropTypes from 'prop-types';
import ProtocolPanelErrorBoundary from 'features/stepByStepProtocol/components/ProtocolPanelHost/ProtocolPanelErrorBoundary';
import ProtocolPanelFrame from 'features/stepByStepProtocol/components/ProtocolPanelFrame/ProtocolPanelFrame';
import ProtocolSkeleton from 'features/stepByStepProtocol/components/ProtocolSkeleton/ProtocolSkeleton';

// The panel is its own chunk: it is downloaded the first time an Agent opens a protocol. Until it arrives
// the frame shows the skeleton; if it cannot load or fails, the frame shows the Unavailable card.
const ProtocolPanel = lazy(() => import('features/stepByStepProtocol/components/ProtocolPanel/ProtocolPanel'));

function ProtocolPanelHost({ transactionId, onClose }) {
    const loading = (
        <ProtocolPanelFrame onClose={onClose}>
            <ProtocolSkeleton />
        </ProtocolPanelFrame>
    );

    return (
        <ProtocolPanelErrorBoundary key={transactionId} transactionId={transactionId} onClose={onClose}>
            <Suspense fallback={loading}>
                <ProtocolPanel transactionId={transactionId} onClose={onClose} />
            </Suspense>
        </ProtocolPanelErrorBoundary>
    );
}

ProtocolPanelHost.propTypes = {
    transactionId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    onClose: PropTypes.func.isRequired,
};

export default ProtocolPanelHost;
